module.exports = __webpack_public_path__ + "static/media/022-global network.19918ab1.png";